<a
  [attr.href]="url"
  [attr.target]="target"
  [attr.disabled]="disabled"
  ngClass="d-button-{{ type }} d-button-{{ level }} d-button-{{ size }}"
  class="d-button cursor-pointer outline-2 outline-offset-2 focus:outline no-underline disabled:opacity-75"
>
  <app-block-list [blockIdList]="content"></app-block-list>
</a>
